import * as React from 'react';
import { SearchFiltersTranslation } from '../constants';
import { FilterConfigurationProps, FilterField } from './types';
import { FilterPanelMenu } from './filter-panel-menu';
import { typeMapping } from './filter-configuration';
import { getCategoryId } from 'app/area/search-filters/filters/category-id';
import { FilterMeatballMenu } from 'app/area/search-filters/filters/filter-meatball-menu';

interface FilterItemFieldProps {
  id: string;
  field: FilterField;
  filterSettings: FilterConfigurationProps;

  translation: SearchFiltersTranslation;
  locale: string;

  onClear: () => void;
}

export const FilterItemField: React.FC<FilterItemFieldProps> = ({
  id, field, translation, locale, onClear, filterSettings: {
    values, onChange, onFilterValidationChange, filterValidation,
    menuValues, onChangeMenu, options, onLoadOptions, updateFilterValues
  } }) => {

  const FilterComponent = typeMapping[field.type].component;
  const menuOptions = typeMapping[field.type].menuOptions;
  const hasMenuOptions = !!menuOptions && Object.keys(menuOptions).length > 0;
  const defaultValues = {
    codetableId: values?.[field?.defaultValueParams?.codetableId],
    readOnly: field?.defaultValueParams?.readOnly,
    cleanValues: field?.defaultValueParams?.cleanValues
  };
  const categoryId = getCategoryId(id);

  return <>
    <FilterComponent
      id={id}
      label={field.label}
      onChange={onChange}
      onFilterValidationChange={onFilterValidationChange}
      onLoadOptions={onLoadOptions}
      updateFilterValues={updateFilterValues}
      translation={translation}
      values={values?.[id]}
      filterValidation={filterValidation}
      options={options[id] && options[id].codes || field.options}
      optionsEndpoint={field.optionsEndpoint}
      optionsParams={field.optionsParams}
      categoryOptionsEndpoint={field.categoryOptionsEndpoint}
      categoryOptionsParams={field.categoryOptionsParams}
      categoryOptions={options?.[categoryId]?.codes}
      fetchingCategoryOptions={options?.[categoryId]?.fetching}
      isHierarchy={field.isHierarchy}
      fetchingOptions={options[id] && options[id].fetching || false}
      defaultValue={defaultValues}
      locale={locale}
      loadOptionsParams={field.loadOptionsParams}
      meatballPanelConfiguration={hasMenuOptions ? {
        meatball: <FilterMeatballMenu
          id={id}
          options={menuOptions}
          values={menuValues[id]}
          onChange={onChangeMenu}
          onClear={onClear}
          translation={translation}
        />, panel: <FilterPanelMenu
          options={menuOptions}
          values={menuValues[id]}
          translation={translation}
        />
      } : null}
      mapOptionsParams={field.mapOptionsParams}
      mapOptionsRequestPayload={field.mapOptionsRequestPayload}
      categoryLoadOptionsParams={field.categoryLoadOptionsParams}
      includeDisabledLabel={field.includeDisabledLabel}
    />
  </>;
};
